export const daily_events = [
  {
    day: 'Tue',
    name: 'Family Meeting',
    description: 'Prepared reservation for parties of 1 of 8',
  },
  {
    day: 'Wed',
    name: 'Classic Wednesday ',
    description: 'Prepared reservation for parties of 1 of 8',
  },
  {
    day: 'Thu',
    name: 'Live Thursdays',
    description: 'Prepared reservation for parties of 1 of 8',
  },
  {
    day: 'Fri',
    name: 'Lift Off Friday',
    description: 'Prepared reservation for parties of 1 of 8',
  },
  {
    day: 'Sat',
    name: 'RoofTop Mix ',
    description: 'Prepared reservation for parties of 1 of 8',
  },
  {
    day: 'Sun',
    name: 'Sip, Paint & Roast',
    description: 'Prepared reservation for parties of 1 of 8',
  },
];

export const isTerrace_Color = {
  primary: '#013709',
  background: '#fff',
  mainbg: '#fbf4e3',
};
export const isForno_Color = {
  primary: '#1d2b1a',
  background: '#fff',
  mainbg: '#ede9d0',
};

export const isReisty_Color = {
  primary: '#BC172F',
  background: 'rgba(188, 23, 47, 0.05)',
  mainbg: '#fff',
};

export function formatDate(inputDate) {
  // Create a Date object
  const date = new Date(inputDate);

  // Define an array of day and month names
  const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const monthsOfYear = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  // Extract the day of the week, month, and day of the month
  const dayOfWeek = daysOfWeek[date.getDay()];
  const month = monthsOfYear[date.getMonth()];
  const dayOfMonth = date.getDate();

  // Format the date string
  const formattedDate = `${dayOfWeek}, ${month} ${dayOfMonth}`;

  return formattedDate;
}
